import EvaluationLaws from "../../../../../components/States/EvaluationLaws";
import { Subdimensiones } from "../../../../../interfaces/Evaluations";
import { allLawsByYear } from "../../../utils/evaluationHelpers";

interface Props {
    subdimensiones: Subdimensiones[];
    years: string[];
}

function EvaluationRowsMultiple({ subdimensiones, years }: Props) {

    return (
        <div className="scrollable-body flex flex-col">
            {subdimensiones.map((row, rowIndex) => (
                <div key={rowIndex} className="flex flex-row gap-4 border-t border-system-light-50 min-w-fit pl-3">
                    {years.map((year, yearIndex) => (
                        <div key={yearIndex} className="flex gap-4">
                            {allLawsByYear(subdimensiones, year).map((law, lawIndex) => {
                                const evaluation = row.evaluaciones?.[year]?.find((evalItem) => {
                                    const nombreEval = String(evalItem.nombre || '').normalize("NFKC").trim().toLowerCase();
                                    const nombreLaw = String(law.law || '').normalize("NFKC").trim().toLowerCase();
                                    return nombreEval === nombreLaw;
                                });
                                return (
                                    <div key={lawIndex} className=" w-[140px] h-[56px] flex flex-col justify-center items-center">
                                        <EvaluationLaws evaluacion={evaluation?.evaluacion ?? 'null'} />
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default EvaluationRowsMultiple;